// @flow

import React, { Component } from "react";
import AdvancedSearch from "../AdvancedSearch";
import Jobs from "../Jobs";
import ManageUsers from "../ManageUsers";
import ManageLogs from "../ManageLogs";
import ManageInterestType from "../ManageInterestType";
import ManageExpenseTypes from "../ManageExpenseTypes";
import ExpenseType from "../ManageExpenseTypes/ExpenseType";
import BillingOrders from "../BillingOrders";
import CreateBillingOrder from "../CreateBillingOrder";
import PaymentAgreement from "../PaymentAgreement";
import Dashboard from "../Dashboard";
import DebtView from "../DebtView";
import LitigationView from "../LitigationView";
import PreLitigationView from "../PreLitigationView";
import ExecutionView from "../ExecutionView";
import LotView from "../LotView";
import CreatePaymentAgreementPage from "../CreatePaymentAgreementPage";
import SimpleSearch from "../SimpleSearch";
import TopMenu from "./TopMenu";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { matchPath } from "react-router";
import * as strings from "../../strings";
import { search, logout, setUser, refreshUser } from "../../actions";
import { IconMenu, MenuItem, MenuDivider } from "react-toolbox/lib/menu";
import styles from "./style.css";
import { withActions } from "../../utils";
import _ from "lodash";

/* eslint-disable */
const ROUTES = [
  { component: Dashboard, path: "/", exact: true },
  { component: Jobs, path: "/jobs", exact: true },
  { component: ManageUsers, path: "/manageUsers", exact: true },
  { component: ManageLogs, path: "/manageLogs", exact: true },
  { component: ManageInterestType, path: "/manageInterestType", exact: true },
  { component: ManageExpenseTypes, path: "/manageExpenseTypes", exact: true },
  { component: ExpenseType, path: "/expenseType/:id", exact: true },
  { component: BillingOrders, path: "/billingOrders/", exact: true },
  { component: CreateBillingOrder, path: "/createBillingOrder/", exact: true },
  {
    component: PaymentAgreement,
    path: "/paymentAgreement/:paymentAgreementId",
    exact: true,
  },
  {
    component: CreatePaymentAgreementPage,
    path: "/createPaymentAgreement/:debtId",
    exact: true,
  },
  { component: DebtView, path: "/debt/:debtId", exact: true },
  { component: LitigationView, path: "/litigation/:litigationId", exact: true },
  {
    component: PreLitigationView,
    path: "/preLitigation/:preLitigationId",
    exact: true,
  },
  { component: ExecutionView, path: "/execution/:executionId", exact: true },
  { component: LotView, path: "/lot/:lotId", exact: true },
  {
    component: SimpleSearch,
    path: "/simpleSearch/:term?",
    exact: true,
    config: true,
  },
  {
    component: AdvancedSearch,
    path: "/advancedSearch",
    exact: true,
    config: true,
  },
  { component: Dashboard }, // This is the default route, it shouldn't get a path, or an exact tag
];
/* eslint-enable */

const UserLogo = ({ className }: { className: any }) => (
  <svg className={className} width="24px" height="24px" viewBox="0 0 24 24">
    <g id="user" fill="#FFFFFF" fillRule="nonzero">
      <path
        d="M24,12 C24,5.38341818 18.6165818,0 12,0 C5.38341818,0 0,5.38341818 0,12 C0,15.4948364 1.50283636,18.6449455 3.89498182,20.8398545 L3.88363636,20.8498909 L4.27287273,21.1780364 C4.29818182,21.1994182 4.32567273,21.2168727 4.35098182,21.2378182 C4.55781818,21.4093091 4.77207273,21.5720727 4.99025455,21.7296 C5.06094545,21.7806545 5.13163636,21.8317091 5.20363636,21.8814545 C5.43665455,22.0420364 5.67578182,22.1943273 5.92014545,22.3387636 C5.97338182,22.3701818 6.02705455,22.4007273 6.08072727,22.4312727 C6.34821818,22.5835636 6.62138182,22.7271273 6.90109091,22.8589091 C6.9216,22.8685091 6.94254545,22.8772364 6.96305455,22.8868364 C7.87461818,23.3105455 8.84770909,23.6216727 9.86530909,23.8053818 C9.89192727,23.8101818 9.91854545,23.8149818 9.9456,23.8197818 C10.2615273,23.8743273 10.5809455,23.9179636 10.9042909,23.9472 C10.9435636,23.9506909 10.9828364,23.9528727 11.0225455,23.9563636 C11.3445818,23.9829818 11.6701091,24 12,24 C12.3268364,24 12.6493091,23.9829818 12.9696,23.9572364 C13.0101818,23.9537455 13.0507636,23.9515636 13.0913455,23.9480727 C13.4120727,23.9188364 13.7288727,23.8765091 14.0417455,23.8228364 C14.0688,23.8180364 14.0962909,23.8132364 14.1233455,23.808 C15.1256727,23.6282182 16.0848,23.3240727 16.9845818,22.9112727 C17.0177455,22.896 17.0513455,22.8816 17.0845091,22.8658909 C17.3537455,22.7393455 17.6168727,22.6027636 17.8747636,22.4574545 C17.9389091,22.4212364 18.0026182,22.3845818 18.0663273,22.3470545 C18.3010909,22.2087273 18.5319273,22.0642909 18.7562182,21.9106909 C18.8369455,21.8557091 18.9159273,21.7976727 18.9957818,21.7400727 C19.1873455,21.6021818 19.3754182,21.4599273 19.5582545,21.3111273 C19.5988364,21.2784 19.6424727,21.2500364 19.6821818,21.2164364 L20.0814545,20.8830545 L20.0696727,20.8730182 C22.4827636,18.6772364 24,15.5127273 24,12 Z M0.872727273,12 C0.872727273,5.86429091 5.86429091,0.872727273 12,0.872727273 C18.1357091,0.872727273 23.1272727,5.86429091 23.1272727,12 C23.1272727,15.3063273 21.6763636,18.2788364 19.3793455,20.3184 C19.2510545,20.2298182 19.1218909,20.1504 18.9896727,20.0840727 L15.2949818,18.2369455 C14.9633455,18.0711273 14.7573818,17.7377455 14.7573818,17.3672727 L14.7573818,16.0769455 C14.8429091,15.9713455 14.9332364,15.8517818 15.0266182,15.7204364 C15.5048727,15.0449455 15.8884364,14.2935273 16.1681455,13.4849455 C16.7210182,13.2222545 17.0779636,12.6715636 17.0779636,12.0497455 L17.0779636,10.5028364 C17.0779636,10.1245091 16.9392,9.75752727 16.6909091,9.46909091 L16.6909091,7.43258182 C16.7136,7.20610909 16.7938909,5.928 15.8692364,4.87374545 C15.0650182,3.95563636 13.7633455,3.49090909 12,3.49090909 C10.2366545,3.49090909 8.93498182,3.95563636 8.13076364,4.87330909 C7.20610909,5.92756364 7.2864,7.20567273 7.30909091,7.43214545 L7.30909091,9.46865455 C7.06123636,9.75709091 6.92203636,10.1240727 6.92203636,10.5024 L6.92203636,12.0493091 C6.92203636,12.5297455 7.1376,12.9778909 7.50676364,13.2802909 C7.86021818,14.6648727 8.58763636,15.7130182 8.85643636,16.0682182 L8.85643636,17.3310545 C8.85643636,17.6871273 8.66225455,18.0144 8.34938182,18.1854545 L4.89905455,20.0674909 C4.78909091,20.1272727 4.68,20.1970909 4.57090909,20.2752 C2.30225455,18.2365091 0.872727273,15.2823273 0.872727273,12 Z"
        id="Shape"
      ></path>
    </g>
  </svg>
);

const buildTopTabs = (_isAdmin, isFinance) =>
  _.chain([
    { path: "/", label: strings.generalStrings.inicialPage },
    {
      path: "/advancedSearch",
      label: strings.processes.processes /* strings.search.advancedSearch */,
    },
    { path: "/jobs", label: strings.generalStrings.tasks },
    isFinance
      ? { path: "/billingOrders", label: strings.billingOrders.billingOrders }
      : undefined,
  ])
    .reject(_.isUndefined)
    .value();

const buildProcessesTopTab = () =>
  _.chain([
    {
      label: strings.processes.preLitigation,
      property: "preLitActive",
      children: [
        {
          path: "/v2/reports/prelitigation",
          label: strings.processes.processes,
        },
      ],
    },
    {
      label: strings.processes.litigation,
      property: "litActive",
      children: [
        {
          path: "/v2/reports/litigation",
          label: strings.processes.processes,
        },
        {
          path: " /v2/litigation/paymentagreement",
          label: strings.processes.paymentAgreement,
        },
        {
          path: "/v2/reports/execformulas",
          label: strings.processes.executionFormula,
        },
      ],
    },
  ])
    .reject(_.isUndefined)
    .value();

// const buildProcessesTopTab = () => ({
//   label: strings.processes.processes,
//   children: [
//     { path: "/processes", label: strings.processes.processes },
//     {
//       path: "/paymentAgreement",
//       label: strings.processes.paymentAgreement,
//     },
//     {
//       path: "/executionFormula",
//       label: strings.processes.executionFormula,
//     },
//   ],
// });

class SearchBox extends Component {
  props: {
    value: string,
    onChange: (string) => {},
    search: () => any,
  };

  handleSubmit(e) {
    e.preventDefault();
    const val = this.props.value;
    this.props.search(encodeURIComponent(val));
  }

  render() {
    return (
      <form
        onSubmit={this.handleSubmit.bind(this)}
        className={styles.searchBoxWrapper}
      >
        <input
          type="search"
          className={styles.searchBox}
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
          placeholder={strings.search.simpleSearchLabel}
        />
      </form>
    );
  }
}

class App extends Component {
  props: {
    history: any,
    suggestions: any,
    expenseTypes: any,
    user: {
      id: number,
      groups: [],
    },
    search: (type: string, params: any, pagination?: any) => any,

    interestTypes: mixed[],

    location: any,
    refreshUser: () => {},
    logout: () => any,
    setUser: () => any,
    actions: any,
  };

  state = {
    searchBox: "",
    isOpen: false,
  };

  componentDidMount() {
    const { suggestions, expenseTypes } = this.props;

    if (_.keys(suggestions).length === 0) {
      this.props.actions.getAllSuggestions();
    }

    if (!expenseTypes || expenseTypes.length === 0) {
      this.props.actions.getAllExpenseTypes();
    }
  }

  componentWillMount() {
    if (this.props.user.id === undefined) {
      this.props.refreshUser();
    }
  }

  shouldShowConfig = () => {
    const configRoutes = ROUTES.filter((route) => !!route.config);
    const match = configRoutes.find((route) =>
      matchPath(this.props.location.pathname, {
        path: route.path,
        exact: route.exact,
      })
    );

    return !!match;
  };

  render() {
    const { isOpen } = this.state;
    const { user } = this.props;
    const { generalStrings } = strings;
    const isAdmin =
      user && user.groups && user.groups.find((group) => group === "Admin");
    const isFinance =
      user && user.groups && user.groups.find((group) => group === "Finance");

    return (
      <div className={styles.root}>
        <div className={styles.header}>
          <div className={styles.headerSearch}>
            <div className={styles.logoWrapper}>
              <div
                className={styles.logo}
                onClick={() => this.props.history.push("/")}
              >
                <b>Private</b>Lawyers
              </div>
            </div>
            <SearchBox
              value={this.state.searchBox}
              onChange={(val) =>
                this.setState({
                  ...this.state,
                  searchBox: val,
                })
              }
              search={(term) =>
                this.props.history.push("/simpleSearch/" + term)
              }
            />
            <IconMenu
              icon={
                <UserLogo
                  className={isOpen ? styles.imgIconOpen : styles.imgIcon}
                />
              }
              position="topRight"
              menuRipple
              className={[isOpen ? styles.openIcon : "", styles.iconMenu].join(
                " "
              )}
              onClick={() =>
                this.setState({
                  isOpen: !this.state.isOpen,
                })
              }
              onHide={() =>
                this.setState({
                  isOpen: false,
                })
              }
            >
              {isAdmin ? (
                [
                  <MenuItem
                    key={0}
                    caption={strings.management.userManagement}
                    className={styles.item}
                    onClick={() => this.props.history.push("/manageUsers")}
                  />,
                  <MenuItem
                    key={1}
                    caption={strings.management.checkLogs}
                    className={styles.item}
                    onClick={() => this.props.history.push("/manageLogs")}
                  />,
                  <MenuItem
                    key={2}
                    caption={strings.management.expenseTypes}
                    className={styles.item}
                    onClick={() =>
                      this.props.history.push("/manageExpenseTypes")
                    }
                  />,
                ]
              ) : (
                <div></div>
              )}
              <MenuDivider />
              <MenuItem
                caption={generalStrings.logout}
                className={styles.item}
                onClick={() => {
                  this.props.setUser({});
                  this.props.logout();
                  this.props.history.push("/");
                }}
              />
            </IconMenu>
          </div>
          <TopMenu
            showConfig={this.shouldShowConfig()}
            tabs={buildTopTabs(isAdmin, isFinance)}
            processTab={buildProcessesTopTab()}
          />
        </div>
        <div className={styles.appBody}>
          <Switch>
            {ROUTES.map((route, index) => (
              <Route
                key={index}
                exact={!!route.exact}
                path={route.path}
                component={route.component}
              />
            ))}
          </Switch>
        </div>
        <ReduxToastr
          timeOut={4000}
          newestOnTop={false}
          preventDuplicates
          position="top-left"
          transitionIn="fadeIn"
          transitionOut="fadeOut"
          progressBar
        />
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    searchResults: store.search || [],
    user: store.user,
    interestTypes: store.interestTypes,
    suggestions: store.suggestions,
    expenseTypes: _.get(store, "expenses.expenseTypes", []),
  };
};

export default connect(mapStateToProps, {
  search,
  logout,
  setUser,
  refreshUser,
})(withActions(withRouter(App)));



// WEBPACK FOOTER //
// ./src/views/App/index.jsx